import HTTP from '@/services/http'

/**
 * 获取多语言平台的页面配置
 * @param key 配置的key
 */
export const getConfig = async (key?: string) => {
  const { data } = await HTTP.get(process.env.CONFIG_URL, { withCredentials: false })
  return key ? data[key] : data
}

type ConfigKeyType =
  | 'downloadTemplateMap'
  | 'immediateImportTemplateMap'
  | 'AccountSubscribePackage'
  | 'sellPrivacyDefaultTemplate'
  | 'oneship-config'
  | 'messageCenterConfig'
  | 'survey'

/** 获取oms配置 */
export const getTargetOmsConfig = async (key: ConfigKeyType) => {
  const res = await HTTP.get(`/ones/api/v1/config/${key}`)
  return res.data?.data?.config
}
